import type { LexicalNode, NodeKey } from 'lexical'
import type { SerializedAdamParagraphNode } from '../../../NotesPlugin/nodes/AdamParagraphNode/AdamParagraphNodeHeadless'
import { AdamParagraphNodeHeadless } from '../../../NotesPlugin/nodes/AdamParagraphNode/AdamParagraphNodeHeadless'

type SerializedListItemTextEditableNode = SerializedAdamParagraphNode

class ListItemTextEditableNodeHeadless extends AdamParagraphNodeHeadless {
    static getType() {
        return 'list-item-text-editable'
    }

    static clone(node: ListItemTextEditableNodeHeadless) {
        return $createListItemTextEditableNodeHeadless(node.getKey())
    }

    static importJSON(
        serializedNode: SerializedListItemTextEditableNode,
    ): ListItemTextEditableNodeHeadless {
        const node = $createListItemTextEditableNodeHeadless()
        node.setFormat(serializedNode.format)
        node.setDirection(serializedNode.direction)
        return node
    }

    exportJSON(): SerializedListItemTextEditableNode {
        return {
            ...super.exportJSON(),
            type: 'list-item-text-editable',
            indent: 0,
        }
    }

    getIndent(): number {
        const container = this.getParentOrThrow()
        return container.getIndent()
    }

    setIndent(indent: number): this {
        const container = this.getParent()
        if (container) container.setIndent(indent)
        return this
    }
}

function $createListItemTextEditableNodeHeadless(
    nodeKey?: NodeKey,
): ListItemTextEditableNodeHeadless {
    return new ListItemTextEditableNodeHeadless(undefined, nodeKey)
}

function $isListItemTextEditableNodeHeadless(
    node: LexicalNode | null | undefined,
): node is ListItemTextEditableNodeHeadless {
    return node instanceof ListItemTextEditableNodeHeadless
}

export {
    type SerializedListItemTextEditableNode,
    $isListItemTextEditableNodeHeadless,
    $createListItemTextEditableNodeHeadless,
    ListItemTextEditableNodeHeadless,
}
